import axios from "@/util/axios";

export default {
    queryByCode: (code) => axios.get({url: "/order/material/process/queryByCode", data: {code}}),

    findStatus: (code) => axios.get({url: "/order/material/process/findStatus", data: {code}})
}